import { ref } from 'vue';

/**
 * @typedef {object} InitialDialogConfig
 * @property {boolean} [isShowing] Whether dialog is showing.
 * @property {() => void} [onDobSubmitted] Message to show.
 * @property {string} [dob] Date of birth.
 * @property {number} [userId] User ID.
 * @property {string} [error] Error.
 */
const initialDialogConfig = {
  isShowing: false,
  onDobSubmitted: () => {},
  dob: null,
  userId: null,
  error: null,
};

const dobDialogConfig = ref(initialDialogConfig);

/** Hide dialog. */
function closeDobDialog() {
  dobDialogConfig.value.isShowing = false;
  dobDialogConfig.value.error = null;
}

/**
 * Show dialog.
 * @param {InitialDialogConfig} config Dialog config.
 */
function showDobDialogWithConfig(config) {
  dobDialogConfig.value = {
    isShowing: true,
    ...config,
  };
}

/** Use dob dialog. */
export function useDobDialog() {
  return { closeDobDialog, showDobDialogWithConfig, dobDialogConfig };
}
